module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_c('navbar', {
    attrs: {
      "title": "餐企对账单-明细"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "common-scroll detail-scroll"
  }, [_c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v("订单号：" + _vm._s(_vm.returnDetailData.bill_no) + "\n\t\t\t\t"), _c('span', {
    staticClass: "nav-btn",
    on: {
      "click": function($event) {
        return _vm.openBillInfo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nav-btn.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.returnDetailData.bill_state == 0) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("未确认")]) : _vm._e(), _vm._v(" "), (_vm.returnDetailData.bill_state == 1) ? _c('span', {
    staticClass: "state-red-font"
  }, [_vm._v("已确认")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bill-all-info bill-all-info-width"
  }, [_c('ul', {
    staticClass: "detail-bill-info-list bill-all-info-width"
  }, [_c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("付款方集团：" + _vm._s(_vm.returnDetailData.pay_name))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("收款方：" + _vm._s(_vm.returnDetailData.receive_name))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("整单备注：" + _vm._s(_vm.returnDetailData.remark))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-wrapper"
  }, [(_vm.uploadDeliverFlag !== undefined || _vm.isZ5) ? _c('div', {
    staticClass: "upload-file-div"
  }, [_c('label', [_vm._v("附件资料：")]), _vm._v(" "), _c('upload-img', {
    attrs: {
      "uploadImgState": _vm.uploadImgState,
      "uploadImgList": _vm.uploadImgList,
      "imgListLength": _vm.otherdata.number,
      "smallDelIco": _vm.smallDelIco,
      "billState": Number(_vm.returnDetailData.bill_state)
    },
    on: {
      "update:smallDelIco": function($event) {
        _vm.smallDelIco = $event
      },
      "attachDelPost": _vm.attachDelPost,
      "attachBeforeUpload": _vm.attachBeforeUpload,
      "attachClick": _vm.attachClick
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "detail-bill-list detail-bill-list-flex"
  }, [_c('li', {
    staticClass: "detail-bill-list-flex-li"
  }, [_c('ul', {
    staticClass: "detail-bill-sonlists returnBill"
  }, [_c('div', {
    staticClass: "detail-bill-sonlist-font"
  }, [_vm._v("实付金额：" + _vm._s(_vm.returnDetails.pay_money))]), _vm._v(" "), _c('div', [_vm._v("应付金额：" + _vm._s(_vm.returnDetails.ap_money))]), _vm._v(" "), _c('div', [_vm._v("抹零金额：" + _vm._s(_vm.returnDetails.wipezero_money))])]), _vm._v(" "), _c('ul', {
    staticClass: "detail-bill-sonlists returnBill"
  }, [_c('div', [_vm._v("付款方式：" + _vm._s(_vm.returnDetails.payment_type))]), _vm._v(" "), _c('div', [_vm._v("优惠金额：" + _vm._s(_vm.returnDetails.discount_money))]), _vm._v(" "), _c('div', [_vm._v(" ")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "detail-bill-footer"
  }, [(_vm.buttonState && _vm.returnDetailData.bill_state != 1) ? _c('div', {
    staticClass: "detail-bill-return f-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.agreen('1')
      }
    }
  }, [_vm._v("同意")])]) : _vm._e(), _vm._v(" "), (_vm.buttonState && _vm.returnDetailData.bill_state != 1) ? _c('div', {
    staticClass: "detail-bill-red f-right"
  }, [_c('a', {
    on: {
      "click": _vm.refuseB
    }
  }, [_vm._v("退回")])]) : _vm._e()]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsB),
      expression: "tipsB"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatusB
    }
  }), _vm._v(" "), _c('item-img', {
    ref: "itemImgRef"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50a02808!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AccountCheckDetailBill.vue
// module id = 567
// module chunks = 1